// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","tooltip":"XeKXqkwXEw5CPDJKxah0X","header":"_2D1ZWgitQtzw9p15ifsgHo","logo":"_3Iz4o3rh3ud4sy6Qr9pHv3","footer":"_3KR9EtmjcarOJQx7U3mYNg"};